/* AHVA "Complete the set" buy box. Adds the legging + any chosen tops to the real cart, then opens the theme's cart drawer. */
(function () {
  var root = document.querySelector('[data-ahva-lp]');
  if (!root) return;
  var data = JSON.parse(root.querySelector('[data-ahva-data]').textContent);
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var cur = data.currency || '$';
  var money = function (c) { var v = c / 100; return cur + (v % 1 ? v.toFixed(2) : v.toFixed(0)); };

  // Gallery
  var main = $('.gallery .main'), tag = $('.fit-tag');
  $$('.thumbs button').forEach(function (b) {
    b.addEventListener('click', function () {
      main.src = b.getAttribute('data-src'); main.removeAttribute('srcset');
      $$('.thumbs button').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
      b.setAttribute('aria-current', 'true');
      if (tag) { var t = b.getAttribute('data-tag'); tag.style.display = t ? '' : 'none'; if (t) tag.textContent = t; }
    });
  });

  // Main size
  var size = null;
  $$('.sizes button').forEach(function (b) {
    b.addEventListener('click', function () {
      $$('.sizes button').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      b.setAttribute('aria-pressed', 'true');
      size = b.getAttribute('data-size');
      $$('.chosen-size', document).forEach(function (el) { el.textContent = size; });
      err('');
      update();
    });
  });

  // Add-ons
  var on = {};
  $$('.addon').forEach(function (el) {
    var key = el.getAttribute('data-key'), btn = $('.add', el);
    btn.addEventListener('click', function () {
      on[key] = !on[key];
      btn.setAttribute('aria-pressed', String(!!on[key]));
      btn.textContent = on[key] ? data.text.added : data.text.add;
      err(''); update();
    });
  });

  function state() {
    var base = size ? data.variants[size].price : data.price;
    var picked = data.addons.filter(function (a) { return on[a.key]; });
    var count = 1 + picked.length;
    var subtotal = base + picked.reduce(function (s, a) { return s + a.price; }, 0);
    var discount = count >= data.bundleCount ? Math.round(subtotal * data.bundlePercent / 100) : 0;
    return { picked: picked, count: count, subtotal: subtotal, discount: discount, total: subtotal - discount };
  }

  function update() {
    var s = state();
    $$('.js-total', document).forEach(function (el) { el.textContent = money(s.total); });
    $$('.js-was').forEach(function (el) { el.textContent = s.discount ? money(s.subtotal) : ''; });
    $$('.js-count').forEach(function (el) { el.textContent = s.count === 1 ? data.text.atc : data.text.atcMany.replace('[n]', s.count); });
    $$('.js-summary').forEach(function (el) { el.textContent = [data.title].concat(s.picked.map(function (a) { return a.title; })).join(' + '); });
    $$('.track span').forEach(function (sp, i) { sp.classList.toggle('on', i < Math.min(s.count, 3)); });
    var msg = $('.msg');
    if (msg) {
      if (s.count === 1) msg.innerHTML = data.text.step1;
      else if (s.count < data.bundleCount) msg.innerHTML = s.subtotal >= data.freeShip ? data.text.step2 : data.text.step2b;
      else msg.innerHTML = data.text.step3.replace('[n]', s.count).replace('[save]', money(s.discount));
    }
  }

  function err(t) {
    var e = $('.err'); if (e) e.textContent = t;
    if (!t) { var h = $('.ahva-hint'); if (h) h.remove(); $$('.needs').forEach(function (x) { x.classList.remove('needs'); }); }
  }

  // Show the message right where the shopper needs to act (the sticky bar may have sent them from far below)
  function hint(t, anchor) {
    err(t);
    var h = $('.ahva-hint');
    if (!h) { h = document.createElement('p'); h.className = 'ahva-hint'; h.setAttribute('role', 'alert'); }
    h.textContent = t;
    anchor.insertAdjacentElement('afterend', h);
    anchor.classList.remove('needs'); void anchor.offsetWidth; anchor.classList.add('needs');
    anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // Add to cart (real)
  function addToCart(btn) {
    if (!size) { var z = $('.sizes'); if (z) hint(data.text.pickSize, z); else err(data.text.pickSize); return; }
    var items = [{ id: data.variants[size].id, quantity: 1 }];
    for (var i = 0; i < data.addons.length; i++) {
      var a = data.addons[i];
      if (!on[a.key]) continue;
      var sel = $('.addon[data-key="' + a.key + '"] select');
      if (!sel.value) { hint(data.text.pickAddon.replace('[t]', a.title), sel.closest('.addon') || sel); sel.focus({ preventScroll: true }); return; }
      items.push({ id: +sel.value, quantity: 1 });
    }
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
    btn.setAttribute('aria-busy', 'true');
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: sections.join(','), sections_url: window.location.pathname })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { err(res.j.description || data.text.error); btn.removeAttribute('aria-busy'); return; }
        var tv = window.themeVariables && window.themeVariables.settings;
        if (tv && tv.cartType === 'page') { window.location.href = window.Shopify.routes.root + 'cart'; return; }
        return fetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          cart.sections = res.j.sections || {};
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: cart } }));
          btn.removeAttribute('aria-busy');
        });
      })
      .catch(function () { err(data.text.error); btn.removeAttribute('aria-busy'); });
  }
  $$('.js-atc', document).forEach(function (b) { b.addEventListener('click', function () { addToCart(b); }); });
  $$('.js-jump', document).forEach(function (b) { b.addEventListener('click', function () { root.scrollIntoView({ behavior: 'smooth' }); }); });

  // Size guide pop-up: opens only from the "Size guide" button by the sizes
  var dlg = $('[data-ahva-size-dialog]');
  if (dlg) {
    $$('[data-ahva-size-open]').forEach(function (b) {
      b.addEventListener('click', function () { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); });
    });
    var closeDlg = function () { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); };
    $$('[data-ahva-size-close]', dlg).forEach(function (b) { b.addEventListener('click', closeDlg); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) closeDlg(); }); // tap outside to close
  }

  // Sticky bar on phones while the main button is off screen
  var mainBtn = $('.main-atc'), sticky = document.querySelector('.ahva-sticky');
  if (mainBtn && sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (e) { sticky.classList.toggle('show', !e[0].isIntersecting); }).observe(mainBtn);
  }
  // Full-screen photo viewer: arrows / swipe / keys between photos.
  // Phones: pinch with two fingers to zoom, drag with one finger to look around, double-tap to zoom in/out.
  // Computers: click to zoom in at that spot, drag to look around, click again to zoom out.
  var lb = $('[data-ahva-lightbox]');
  if (lb && lb.showModal) {
    var lbImg = $('[data-lb-img]', lb), stage = $('[data-lb-stage]', lb), count = $('.lb-count', lb), hint = $('[data-lb-hint]', lb), idx = 0;
    var shots = $$('.thumbs button').map(function (b) { return b.getAttribute('data-full') || b.getAttribute('data-src'); });
    var touchDevice = window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches;
    if (hint) hint.textContent = touchDevice ? 'Pinch to zoom' : 'Click the photo to zoom';
    var MAX = 4, z = { s: 1, x: 0, y: 0 };

    var apply = function (animate) {
      lbImg.classList.toggle('is-animating', !!animate);
      lbImg.style.transform = 'translate(' + z.x + 'px,' + z.y + 'px) scale(' + z.s + ')';
      lbImg.classList.toggle('is-zoomed', z.s > 1.01);
      lb.classList.toggle('is-zoomed', z.s > 1.01);
    };
    // Keep the zoomed photo covering the screen (no dragging it off into empty space)
    var clamp = function () {
      var w = lbImg.offsetWidth, h = lbImg.offsetHeight;
      var sw = stage.clientWidth, sh = stage.clientHeight;
      var ox = lbImg.offsetLeft, oy = lbImg.offsetTop;
      if (w * z.s <= sw) { z.x = (sw - w * z.s) / 2 - ox; } else { z.x = Math.min(-ox, Math.max(sw - ox - w * z.s, z.x)); }
      if (h * z.s <= sh) { z.y = (sh - h * z.s) / 2 - oy; } else { z.y = Math.min(-oy, Math.max(sh - oy - h * z.s, z.y)); }
    };
    var reset = function (animate) { z.s = 1; z.x = 0; z.y = 0; apply(animate); };
    // Zoom to scale ns, keeping the screen point (cx, cy) under the fingers / cursor
    var zoomAt = function (ns, cx, cy, animate) {
      ns = Math.max(1, Math.min(MAX, ns));
      if (ns <= 1.01) { reset(animate); return; }
      var r = stage.getBoundingClientRect();
      var lx = cx - r.left - lbImg.offsetLeft, ly = cy - r.top - lbImg.offsetTop;
      var px = (lx - z.x) / z.s, py = (ly - z.y) / z.s;
      z.s = ns; z.x = lx - px * ns; z.y = ly - py * ns;
      clamp(); apply(animate);
    };

    var show = function (i) {
      if (!shots.length) return;
      idx = (i + shots.length) % shots.length;
      reset(false); lbImg.src = shots[idx];
      count.textContent = (idx + 1) + ' / ' + shots.length;
    };
    var openLb = function () {
      var cur = $$('.thumbs button').findIndex(function (b) { return b.getAttribute('aria-current') === 'true'; });
      show(cur < 0 ? 0 : cur);
      lb.showModal(); document.documentElement.classList.add('ahva-lb-open');
    };
    $$('[data-ahva-zoom-open]').forEach(function (el) { el.addEventListener('click', openLb); });
    $('[data-lb-close]', lb).addEventListener('click', function () { lb.close(); });
    $('[data-lb-prev]', lb).addEventListener('click', function () { show(idx - 1); });
    $('[data-lb-next]', lb).addEventListener('click', function () { show(idx + 1); });
    lb.addEventListener('close', function () { reset(false); document.documentElement.classList.remove('ahva-lb-open'); });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') show(idx - 1);
      if (e.key === 'ArrowRight') show(idx + 1);
    });

    // ---- Touch: pinch, one-finger pan, swipe, double-tap ----
    var t = null, lastTap = 0;
    var dist = function (a, b) { return Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY); };
    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        t = { mode: 'pinch', d0: dist(e.touches[0], e.touches[1]) || 1, s0: z.s };
      } else if (e.touches.length === 1) {
        var p = e.touches[0];
        t = { mode: z.s > 1.01 ? 'pan' : 'swipe', x0: p.clientX, y0: p.clientY, zx: z.x, zy: z.y, moved: false };
      }
      lbImg.classList.remove('is-animating');
    }, { passive: true });
    stage.addEventListener('touchmove', function (e) {
      if (!t) return;
      e.preventDefault();
      if (t.mode === 'pinch' && e.touches.length === 2) {
        var a = e.touches[0], b = e.touches[1];
        zoomAt(t.s0 * dist(a, b) / t.d0, (a.clientX + b.clientX) / 2, (a.clientY + b.clientY) / 2, false);
      } else if (t.mode === 'pan' && e.touches.length === 1) {
        var p = e.touches[0];
        z.x = t.zx + (p.clientX - t.x0); z.y = t.zy + (p.clientY - t.y0);
        t.moved = true; clamp(); apply(false);
      } else if (t.mode === 'swipe' && e.touches.length === 1) {
        if (Math.abs(e.touches[0].clientX - t.x0) > 8) t.moved = true;
      }
    }, { passive: false });
    stage.addEventListener('touchend', function (e) {
      if (!t) return;
      if (t.mode === 'pinch') {
        if (e.touches.length === 1) { var p = e.touches[0]; t = { mode: 'pan', x0: p.clientX, y0: p.clientY, zx: z.x, zy: z.y, moved: true }; }
        else { if (z.s < 1.05) reset(true); t = null; }
        return;
      }
      var c = e.changedTouches[0];
      if (t.mode === 'swipe') {
        var dx = c.clientX - t.x0, dy = c.clientY - t.y0;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) { show(idx + (dx < 0 ? 1 : -1)); t = null; return; }
      }
      if (!t.moved) {
        var now = Date.now();
        if (now - lastTap < 300) { if (z.s > 1.01) reset(true); else zoomAt(2.5, c.clientX, c.clientY, true); lastTap = 0; }
        else lastTap = now;
      }
      t = null;
    });

    // ---- Mouse: click to zoom, drag to pan ----
    var drag = null, dragged = false;
    lbImg.addEventListener('click', function (e) {
      if (touchDevice) return;
      if (dragged) { dragged = false; return; }
      if (z.s > 1.01) reset(true); else zoomAt(2.5, e.clientX, e.clientY, true);
    });
    stage.addEventListener('mousedown', function (e) {
      if (z.s <= 1.01) return;
      drag = { x: e.clientX, y: e.clientY, zx: z.x, zy: z.y }; dragged = false; e.preventDefault();
      lbImg.classList.remove('is-animating');
    });
    window.addEventListener('mousemove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
      if (Math.abs(dx) + Math.abs(dy) > 4) dragged = true;
      z.x = drag.zx + dx; z.y = drag.zy + dy; clamp(); apply(false);
    });
    window.addEventListener('mouseup', function () { drag = null; });
    window.addEventListener('resize', function () { if (lb.open) reset(false); });
  }

  update();
})();
